import { SideMenuEntry, SideMenuItemType } from '../types';
import DropdownGroup from './dropdownGroup';
import PageRow from './pageRow';
import SectionGroup from './sectionGroup';

interface Props {
	item: SideMenuEntry;
	/** When false the menu is in its collapsed (icon-only) rail state. */
	showLabel: boolean;
}

/**
 * Renders one side-menu entry, picking the right presentation based on its
 * {@link SideMenuItemType}. Keeps the container a thin `map` over entries.
 *
 * Every variant renders an `<li>` so it can live directly inside the `<ul>`
 * (MUI `List`) of its parent — keeping the list markup valid.
 */
const SideMenuItem = ({ item, showLabel }: Props) => {
	switch (item.type) {
		case SideMenuItemType.Page:
			return <PageRow page={item} showLabel={showLabel} />;
		case SideMenuItemType.Section:
			return <SectionGroup section={item} showLabel={showLabel} />;
		case SideMenuItemType.Dropdown:
			return <DropdownGroup dropdown={item} showLabel={showLabel} />;
	}
};

export default SideMenuItem;
